interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
}

export default function SectionHeading({ eyebrow, title, desc, align = "left" }: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "flex flex-col items-center text-center" : "flex flex-col items-start"}>
      <div className="flex items-center gap-3">
        <span className="h-px w-8 bg-accent-500" />
        <span className="font-label text-xs md:text-sm tracking-[0.28em] text-accent-700 uppercase whitespace-nowrap">
          {eyebrow}
        </span>
      </div>
      <h2 className="mt-4 font-heading text-2xl md:text-4xl font-semibold text-foreground-950 leading-snug">
        {title}
      </h2>
      {desc && (
        <p className={`mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl ${isCenter ? "" : ""}`}>
          {desc}
        </p>
      )}
    </div>
  );
}